"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const Image_1 = __importDefault(require("../Image"));
const imgBlack = "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_black.png";
const imgWhite = "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_white.png";
const Wrapper = styled_components_1.default.a `
  & > span > img {
    height: 16px;
    width: 108px;
    object-fit: contain;
    vertical-align: middle;
    background-color: transparent !important;

    ${bitcoincom_pkg_theme_1.media.md `
      height: 20px;
      width: 135px;
    `}
  }
`;
/**
 * Main Bitcoin.com Logo
 * @param {Object} props component props
 * @param {boolean} props.contrast @default false set to white
 */
const Logo = (_a) => {
    var { contrast = false } = _a, rest = __rest(_a, ["contrast"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ href: "https://www.bitcoin.com/" }, rest, { "aria-label": "Bitcoin.com link" }),
        react_1.default.createElement(Image_1.default, { width: 135, height: 20, src: contrast ? imgWhite : imgBlack, alt: "Bitcoin.com" })));
};
exports.default = Logo;
//# sourceMappingURL=Logo.js.map